import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '番剧分类', href: '/category/hot-blooded' },
    { label: '动漫文章', href: '/article/article-001' },
    { label: '关于我们', href: '/about' },
  ],
  categories: [
    { label: '热血战斗', href: '/category/hot-blooded' },
    { label: '奇幻冒险', href: '/category/fantasy-adventure' },
    { label: '异世界', href: '/category/isekai' },
    { label: '恋爱日常', href: '/category/romance-daily' },
    { label: '科幻机甲', href: '/category/sci-fi-mecha' },
    { label: '悬疑推理', href: '/category/mystery' },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <Link
              to="/"
              className="text-3xl md:text-4xl font-bold font-heading text-background-50 cursor-pointer whitespace-nowrap"
            >
              樱花动漫
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-xs">
              专注手机动漫的门户网站，提供全面的动漫大全资源。专为移动端优化，让您随时随地畅享动漫世界。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="http://knsink.cn/"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                aria-label="站内动态"
              >
                <i className="ri-notification-3-line text-base"></i>
              </a>
              <a
                href="http://knsink.cn/category/hot-blooded"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                aria-label="热门内容"
              >
                <i className="ri-fire-line text-base"></i>
              </a>
              <a
                href="http://knsink.cn/about"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                aria-label="联系我们"
              >
                <i className="ri-mail-line text-base"></i>
              </a>
              <a
                href="http://knsink.cn/article/article-001"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-background-700 text-background-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                aria-label="精选文章"
              >
                <i className="ri-article-line text-base"></i>
              </a>
            </div>
          </div>

          <div className="flex gap-12 md:gap-16">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-4">
                快速导航
              </h4>
              <ul className="flex flex-col gap-3">
                {footerLinks.navigation.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-4">
                热门分类
              </h4>
              <ul className="flex flex-col gap-3">
                {footerLinks.categories.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-4">
              <div>
                <h5 className="text-xs text-background-500 mb-1">地址</h5>
                <p className="text-sm text-background-300">北京市朝阳区动漫产业园区 A座 1208室</p>
              </div>
              <div>
                <h5 className="text-xs text-background-500 mb-1">电话</h5>
                <p className="text-sm text-background-300">+86 400-888-0666</p>
              </div>
              <div>
                <h5 className="text-xs text-background-500 mb-1">邮箱</h5>
                <p className="text-sm text-background-300">hello@knsink.cn</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 樱花动漫 版权所有 | 京ICP备2025000001号
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/about"
              className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              隐私政策
            </Link>
            <Link
              to="/about"
              className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              服务条款
            </Link>
            <Link
              to="/about"
              className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
